import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

export default ({ loading, onClick, type, variant, disabled, title, children }) => {
    return (
        <>
            <div style={{paddingRight: '1.5rem'}}><Spinner hidden={!loading} animation="border" role="status" aria-hidden="true" /></div>
            <Button title={title || ''} type={type || 'button'} hidden={loading} variant={variant || 'primary'} onClick={onClick} disabled={disabled || loading}>
                {children}
            </Button>
        </>
    );
}